import { useDispatch, useSelector } from "react-redux";
import {
  setFinalTradeType,
  setStopLossTriggerPrice,
  setTakeProfitTriggerPrice,
  setTradeSize,
} from "../../../redux/trade-form/tradeFormSlice";
import { setTradeType } from "../../../redux/trade/actions";
import { message } from "antd";
import { roundToPrecision } from "../utils/helper";
import useAssetAmount from "./useAssetAmount";
import useCheckPortfolio from "./useCheckPortfolio";
import useCheckOrderLimits from "./useCheckOrderLimits";
import useAmountLimits from "./useAmountLimits";
import useSuggestedSignal from "../../../hooks/useSuggestedSignal";
import { useLocation } from "react-router-dom";

function useAiSuggestion() {
  const {
    tradeForm: {
      aiSuggestion,
      aiSuggestionStatus,
      aiSuggestionError,
      tradeType,
      assetPrice,
      targetCoin,
    },
  } = useSelector((state) => state);

  const location = useLocation();

  const isInAiAssistant = location.pathname?.includes("ai-assistant/assistant");
  const isInInsight = location?.pathname?.includes("insight");

  const oppositeSignal = isInAiAssistant
    ? "ai-trade"
    : isInInsight
      ? "insight-trade"
      : "trade";

  const {
    signal,
    stopLoss,
    takeProfit,
    positionSize: suggestedPS,
    signalDate,
    signalColor,
  } = useSuggestedSignal({ coin: targetCoin, oppositeSignal });

  const { nativeAmount, usdAmount } = useAssetAmount();
  const { budget } = useCheckPortfolio();
  const { amountPrecision } = useCheckOrderLimits();
  const { averageNativeRange, averageUsdRange } = useAmountLimits();

  const dispatch = useDispatch();

  const isLoading = aiSuggestionStatus === "loading";
  const prediction = signal;

  const isError = aiSuggestionStatus === "error";
  const date = signalDate;
  const confidence = aiSuggestion?.confidence?.toFixed(2);
  const positionSize = suggestedPS / 100;

  const applyAllSuggestion = () => {
    if (!prediction && !!stopLoss) return message.error("Something went wrong");

    if (!prediction?.toLowerCase()?.includes("hold")) {
      const tradeType = prediction?.toLowerCase()?.includes("buy")
        ? "buy"
        : "sell";

      dispatch(setTradeType(tradeType));
      dispatch(setFinalTradeType(tradeType));
    }

    const native =
      tradeType === "buy"
        ? (positionSize * budget) / assetPrice
        : positionSize * nativeAmount;
    const usd =
      tradeType === "buy" ? positionSize * budget : positionSize * usdAmount;
    dispatch(
      setTradeSize(
        roundToPrecision(native, amountPrecision, averageNativeRange),
        // native,
        roundToPrecision(usd, 0.01, averageUsdRange),
        positionSize * 100,
      ),
    );
    dispatch(setStopLossTriggerPrice(stopLoss / 100));
    dispatch(setTakeProfitTriggerPrice(takeProfit / 100));

    return message.success("All AI suggestions are applied.");
  };

  return {
    isLoading,
    prediction,
    sl_percent: stopLoss / 100,
    tp_percent: takeProfit / 100,
    isError,
    error: aiSuggestionError,
    date,
    confidence,
    applyAllSuggestion,
    positionSize,
    signalColor,
  };
}

export default useAiSuggestion;
